<template>
    <!-- 修改密码 -->
    <div class="forGetPass">

        <el-steps :active="active">
            <el-step title="身份验证" icon="el-icon-edit"> </el-step>
            <el-step title="重置密码" icon="el-icon-upload"> </el-step>

        </el-steps>
        <!-- 步骤一 -->
        <div class="buzou" v-if="active === 0">
            <el-input
                placeholder="请输入手机号"
                class="im_phone"
                v-model="mobile"
            ></el-input>
            <el-input
                placeholder="请输入短信验证码"
                v-model="codes"
                class="input-with-select"
            >
                <el-button slot="append" type="primary" @click="getSend"
                    >获取验证码</el-button
                >
            </el-input>
            <el-button class="nextchange" @click="next" type="primary"
                >下一步</el-button
            >
        </div>
        <!-- 步骤二 -->
        <div class="buzou" v-if="active === 1">
            <el-input
                placeholder="请输入新密码"
                v-model="newPassword"
                class="im_phone"
                show-password
            ></el-input>
            <el-input
                placeholder="请再次输入新密码"
                v-model="resultnewPassword"
                class="input-with-select"
                show-password
            >
            </el-input>
            <el-button class="nextchange" @click="next" type="primary"
                >确认修改</el-button
            >
        </div>
    </div>
</template>
<script>
import { send, userRestpwd } from "@/api/index.js";
export default {
    data() {
        return {
            active: 0,
            mobile: "",
            codes: "",
            newPassword: "",
            resultnewPassword: ""
        };
    },
    created() {

    },
    methods: {
        next() {

            if (this.active === 0) {
                if(this.mobile == "" || this.codes == ""){
                    return this.$message.error('不能为空')
                }
                let obj = {
                    mobile:this.mobile,
                    codes:this.codes
                }
                window.sessionStorage.setItem("obj",JSON.stringify(obj));
            } else if (this.active === 1) {
               let code = JSON.parse(window.sessionStorage.getItem("obj"));
               console.log(code);

                console.log(this.mobile);
                console.log(this.newPassword);
                console.log(this.resultnewPassword);
                if (this.newPassword !== this.resultnewPassword) {
                    return this.$message.error("输入密码不一致");
                }

                // 修改密码
                // mobile: "18516805339", newpassword: "zhy199999", captcha: "1029"
                userRestpwd(
                    {
                        mobile: code.mobile,
                        newpassword: this.newPassword,
                        captcha: code.codes
                    },

                ).then(res => {
                    console.log(res);
                    if (res.code !== 1) {
                        // if (this.active++ > 1) this.active = 0;
                        this.$message.error(res.msg);
                        return;
                    }
                    //修改正确
                    // window.sessionStorage.removeItem('userInfo')
                   	this.$emit('logType',{
							type:'3'
                    })
                    this.$router.go(0);
                });
            }
            if (this.active++ > 1) this.active = 0;
        },
        //获取验证码
        getSend() {

            send({ mobile: this.mobile, event: "resetpwd" }).then(res => {
                if (res.code !== 1) {
                    return this.$message.error(res.msg);
                }
                return this.$message.success("发送成功");
            });
        }
    }
};
</script>
<style lang="less" scoped>
.forGetPass{
    width: 1069px;
height: 563px;
background: #FFFFFF;
border-radius: 16px;
padding: 100px;
}
.my-title {
    font-size: 20px;
    padding: 0 10px;
    border-left: 5px solid #ff6701;
    margin-bottom: 10px;
    margin-left: -10px;
    line-height: 40px;
    font-weight: 400;
}
.buzou {
    display: flex;
    justify-content: center;

    flex-direction: column;
    margin: 92px 0 0 280px;
    position: relative;
    /deep/ .el-input__inner {
        width: 394px;
        height: 49px;
        border-radius: 25px;

        margin-bottom: 32px;

        // border: 1px solid #D8D8D8;
    }
    /deep/ .el-input-group__append {
        position: absolute;
        top: 0;
        right: 193px;
        width: 132px;
        height: 49px;
        background: #0097fe;
        border-radius: 0px 25px 25px 0px;
        line-height: 49px;

        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
    }
    .nextchange {
        width: 394px;
        height: 49px;
        background: #0097fe !important;
        border-radius: 25px;
    }
    .el-button.is-circle {
        border-radius: 50%;
        width: 122px;
        height: 122px;
        background: #0097fe;
    }
    .success_text {
        width: 88px;
        height: 30px;
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 30px;
    }
    /deep/.el-icon-check {
        font-size: 60px !important;
    }
    .qiu {
        display: flex;
        flex-direction: column;
        padding-left: 130px;
        padding-bottom: 50px;
        span {
            padding: 20px 20px 0 0;
                padding-left: 25px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/forgetPaaword.vue